var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-scrollable modal-lg" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Lock a plan version: " + _vm._s(_vm.projectName)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("div", { staticClass: "text-center my-5" }, [
                        _vm._m(0),
                      ])
                    : _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "alert alert-info mb-3",
                            attrs: { role: "alert" },
                          },
                          [
                            _vm._v(
                              "\n                            By default, this scenario always follows the project’s current "
                            ),
                            _c("em", [_vm._v("Active")]),
                            _vm._v(
                              " plan.\n                            You can lock it to a specific version below if needed.\n                            "
                            ),
                            _vm.lockedPlanId !== null
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-link p-0 align-baseline",
                                    attrs: { type: "button" },
                                    on: { click: _vm.resetToDefault },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Reset to default\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "list-group" },
                          [
                            _vm._l(_vm.orderedPlans, function (p) {
                              return _c(
                                "button",
                                {
                                  key: p.Id,
                                  staticClass:
                                    "list-group-item list-group-item-action d-flex justify-content-between align-items-center plan-row",
                                  attrs: {
                                    type: "button",
                                    "aria-pressed": _vm.lockedPlanId === p.Id,
                                    title: p.Name,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleLock(p.Id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "mr-2",
                                        class:
                                          _vm.lockedPlanId === p.Id
                                            ? "fa-solid fa-circle-check text-primary"
                                            : "fa-regular fa-circle text-muted",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "font-weight-semibold":
                                              _vm.lockedPlanId === p.Id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(p.Name) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  p.Id === _vm.activePlanId
                                    ? _c(
                                        "span",
                                        { staticClass: "badge badge-success" },
                                        [_vm._v("Active")]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.orderedPlans.length === 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "list-group-item text-muted small",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                No plans found for this project.\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", disabled: !_vm.canConfirm },
                      on: { click: _vm.handleConfirm },
                    },
                    [
                      _vm._v(
                        "\n                        Confirm\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("h5", [
      _c("i", { staticClass: "fa fa-spinner fa-spin mr-2" }),
      _vm._v(
        "\n                            Loading plans...\n                        "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }